import DialogForm from '@/components/Dialogs/DialogForm'

export default {
    components: {
        DialogForm,
    },
    props: {
        screen:{
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
          loading: true,
          form: {
              ProductId: '', // 产品主键
              Num: 0, // 产品数量
              // User: '', // 业务员id
              DeliveryType: 0, // 提货方式
              CustomNo: '', //客户号（SAP企业编号）
          },
          formPay:{
            Vcode:'',
            LoginPortId:'1', // 仓库id
          },
          users: [],
          info: {},
          url: {
              saveCar: SZH.assets.api + '/Custom/SaveCar',
              get: SZH.assets.api + "/Order/GetProductForCreateOrder",
              get1: SZH.assets.api + "/Order/GetSAPBalanceForCreateOrder",
              get2: SZH.assets.api + "/Product/GetOffProductForCreateOrder",
              submit: SZH.assets.api + "/Order/CreateOrder",
              company: SZH.assets.api + "/Custom/GetSelectCompanyForWeb",
              pay: SZH.assets.api + "/Order/OffProOrderToPay",
              GetOrderInfo: SZH.assets.api + "/Order/GetOrderInfo",
              GetCurrentProduct: SZH.assets.api + "/Product/GetCurrentProduct",
              GetSystemConfigure: SZH.assets.api + "/Market/GetSystemConfigure",
              SaveAppointmentOrderInfo: SZH.assets.api + "/Order/SaveAppointmentOrderInfo",
          },
          loadingScreen: null,
          loadingScreen1: null,
          fullscreenLoading: false,
          buttonCanClick: true,
          Orders:[],

          proName:'',
          // 0112
          ProductGroupId:'',
        //  企业Id
          CompanyId:'',
          CompanyName:'',
          isThrid:'',
          SalesUserName:''
        }
    },
    methods: {
        loadData() {
            var self = this;
            var url = self.url.get;
            self.$http.post(url, {
              ProductId : self.form.ProductId,
              CompanyId:self.CompanyId
            }).then(result => {
                if (result.state == true && result.data != null) {
                    self.CompanyName = result.data.CompanyName;
                    self.SalesUserName = result.data.SalesUserName;
                    self.form.CustomNo = result.data.CompanyNo;
                    self.info = result.data.ProductInfo;
                    // self.info.Price = 5000;
                    self.form.WarehouseName = result.data.WarehouseName;
                    self.form.Balance = result.data.Balance;
                    // self.users = result.data.Users;
                    self.form.User = '';
                    self.info.SingeLimitCount = result.data.SingeLimitCount;
                } else if(result){
                    self.$alert(result.message || '当前订单信息失效，请重新下单', '无法购买', {
                        confirmButtonText: '确定',
                        type: 'error',
                        center: true,
                        callback: action => {
                        }
                      });
                }
                self.loading = false;
            }, () => {
                self.loading = false;
            });
        },
        goBack() {
            this.$router.go(-1);
        },
        turnTo(url) {
            this.$router.push({
                path: url
            })
        },
        toFixed(num, f) {
            if(f == null || f == undefined) f = 2;
            return parseFloat(num != null && num != undefined ? num.toFixed(f, 3) : '0.00')
        },
        submit() {
            var self = this;

            // if (!self.form.User) {
            //   self.$message.error('请先选择业务员');
            //   return false;
            // }
            if(!self.form.Num){
              self.$message.error('请输入购买数量!');
              return
            }
          // self.$router.push({
          //     path: '/Menu/PayOrder',
          //   })
          self.loadingScreen = this.$loading({
            text: '订单信息提交中, 请勿刷新页面...',
            spinner: 'el-icon-loading',
            background: 'rgba(255, 255, 255, 0.75)'
          });
          self.$http.post(self.url.submit, self.form).then(result => {
            if (result.state == true) {
              self.$router.push({
                path: '/Menu/PayOrder',
                query:{
                  OrderId:result.data
                }
              })
            } else {
              self.$message.error(result.message);
            }
            self.loadingScreen.close();
          }, () => {
            self.loadingScreen.close();
          });


        },
        checkMoneyFun(){
          let self = this;
          if(self.form.Balance>self.sumPrice || self.form.Balance == self.sumPrice){
            // 获取产品组的产品id
            self.getProductId();
          //  切换
          //   self.inputPassword()

          }else{
            self.$alert('您的定金余额不足，请先充值....', '提示', {
              confirmButtonText: '去充值',
              center: true,
              callback: action => {
                self.$router.push({
                  path:'/Charge'
                });
              }
            });
          }
        },
        getProductId(){
          let self = this;
          self.$http.post(self.url.GetCurrentProduct, {
            Data:{
              Id:self.ProductGroupId,
              Quantity:self.form.Num
            }
          }).then(result => {
            if (result.State == 1) {
              self.form.ProductId = result.Data;
              self.inputPassword()
            } else {
              self.$message.error(result.Message);
            }
          }, () => {
            self.$message.error('数据获取失败，请检查您的网络是否可用。');
          });
        },
        inputPassword(){
          let self = this;
          self.$prompt('请输入支付密码', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            center:true,
            inputType:'password'
          }).then(({ value }) => {
              self.form.Vcode = hex_md5(value);
              //支付密码验证成功之后调用创建订单接口
              self.buttonCanClick = true;
              self.submitOrder();
          }).catch(() => {
            self.$message({
              type: 'info',
              message: '取消输入'
            });
            self.buttonCanClick = true;
          });
        },
        submitOrder(){
          let self = this;
          self.loadingScreen = this.$loading({
            text: '订单信息提交中, 请勿刷新页面...',
            spinner: 'el-icon-loading',
            background: 'rgba(255, 255, 255, 0.75)'
          });
          // TODO 接口不合并的话就需要改成submit
          self.$http.post(self.url.submit, {
            Data: self.form
          }).then(result => {
            if (result.State == 1) {
              //TODO 如果有问题立刻撤回
              // self.$router.push({
              //   path: '/My/OrderList',
              // })
              var param = {
                type:self.productType
              };
              param.id = [result.Data];
              self.payOrderDetail(param);
            } else {
              self.$alert(result.Message || '当前订单信息失效，请重新下单', '订单创建失败！', {
                confirmButtonText: '确定',
                type: 'error',
                center: true,
                callback: action => {
                  self.$router.push({
                    path:'/List'
                  });
                }
              });

            }
            self.loadingScreen.close();
            // self.loadingScreen.close();
          }, () => {
            self.loadingScreen.close();
          });
        },
        payOrderDetail(param){
          let self = this;
          var id = {
            OffLine:true,
            ids:param.id
          };
          self.$http.post(self.url.get1, {
            Data:id
          }).then(result => {
            if (result.State == 1) {
              self.formPay.LoginPortId = result.Data.Payment[0].Id;
              self.Orders = result.Data.Orders;
              self.payOrderOffline();
            } else {
              self.$message.error(result.Message);
              self.loadingScreen.close();
            }
          }, () => {
            self.$message.error('数据获取失败，请检查您的网络是否可用。');
            self.loadingScreen.close();
          });
        },
        //支付接口渠道
        payOrderOffline(){
          let self = this;
          self.formPay.Vcode = self.form.Vcode;
          self.$nextTick(()=>{
            self.loadingScreen = this.$loading({
              text: '订单支付中, 请勿刷新页面...',
              spinner: 'el-icon-loading',
              background: 'rgba(255, 255, 255, 0.75)'
            });
          });

          var order = [];
          for(var i = 0;i<self.Orders.length;i++){
            order.push(self.Orders[i].OrderId);
          }
          self.formPay.OrderNos = order;
          self.$http.post(self.url.pay, {
            Data:self.formPay
          }).then(result => {
            if (result.State == 1) {
              // self.$message.success('支付成功');
              self.setintervalResult(self.Orders[0].OrderId);

            } else {

              self.$message.error(result.Message);
            }
            self.loadingScreen.close();
          }, () => {
            self.loadingScreen.close();
            self.$message.error('数据获取失败，请检查您的网络是否可用。');
          });
        },
        setintervalResult(orderId){
          var self = this;
          self.$nextTick(()=>{
            self.loadingScreen1 = self.$loading({
              lock: true,
              text: '努力创建订单建议耐心等待....',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
          });
          let times = setInterval(()=>{
            self.$http.post(self.url.GetOrderInfo, {
              Data: orderId
            }).then(result => {
                if (result.State == 1 && result.Data) {
                  if(result.Data.orderEntity1.OrderStatus == 1 || result.Data.orderEntity1.OrderStatus == 2){
                    self.$router.push({
                      path: '/My/OrderList',
                    })
                    self.loadingScreen1.close();
                    clearInterval(times);
                  }else if(result.Data.orderEntity1.OrderStatus == -5){
                    self.$router.push({
                      path: '/My/orderdetail',
                      query:{ id: self.Orders[0].OrderId }
                    });
                    self.loadingScreen1.close();
                    clearInterval(times);
                  }
                }
                else {

                }
              }, () => {

              });
          },3000)

        },
        onScorePayClick() {

        },
        close() {
            var userAgent = navigator.userAgent;
            if (userAgent.indexOf("Firefox") != -1 || userAgent.indexOf("Chrome") != -1) {
                location.href = "about:blank";
            } else {
                window.opener = null;
                window.open('', '_self');
            }
            window.close();
        },
    },
    computed: {
        productImg() {
            return this.info.Images && this.info.Images.length > 0 ? SZH.assets.image + this.info.Images[0] : ""
        },
        quanNum() {
            return Math.ceil(this.assent / (this.info.Price || 1));
        },
        buyQuanNum() {
            return this.form.IsUsingExistCoupon ? this.quanNum > this.info.quanNum ? this.quanNum - this.info.quanNum : 0 : this.quanNum;
        },
        qp() {
            if(!this.productType) {
                return this.toFixed((this.info.Price));
            }
            else {
                return this.toFixed((this.info.Price - this.form.PreferencePrice));
            }
        },
        sumPrice() {
            // if(!this.productType) {
            //     return this.toFixed(this.qp * this.numberOfCars);
            // }
            // else {
            //     return this.toFixed(this.qp *  this.form.Num);
            // }
            return this.toFixed(this.qp *  this.form.Num);
            // console.log("33333",this.toFixed(this.qp *  this.form.Num));
            // return this.toFixed(this.qp *  this.form.Num);
        },
        canSubmit() {
            return this.buttonCanClick && this.sumPrice > 0
        }
    },
    created() {
    },
    mounted() {
        this.proName = this.$route.query.n;
        this.CompanyId = this.$route.query.CompanyId;
        this.form.ProductId = sessionStorage.getItem('orderFormId');
        this.isThrid = sessionStorage.getItem('isThrid');
        this.loadData();
    },
    watch: {}
}



// WEBPACK FOOTER //
// ./src/views/Order/order.js